import { FooterLink } from '@/types/partnerConfig'

type PremadeFooterLinks = {
  [key: string]: FooterLink[]
}

const FAQs = {
  GBR: 'https://support.babylonhealth.com/hc/en-us',
  USA: 'https://us-support.babylonhealth.com/hc/en-us',
  CAN: 'https://www.telus.com/en/bc/health/personal/babylon/support',
}

const TANDCs = {
  GBR: 'https://www.babylonhealth.com/terms',
  USA: 'https://www.babylonhealth.com/us/tou',
  CAN: 'https://www.babylonhealth.com/ca/telus/terms',
}

const PRIVACY = {
  GBR: 'https://www.babylonhealth.com/terms/privacy',
  USA: 'https://www.babylonhealth.com/us/privacy',
  CAN: 'https://www.babylonhealth.com/ca/telus/privacy-policy',
}

// TODO: Move these to product config
const GBRFooterLinks: FooterLink[] = [
  {
    key: 'faqs',
    link: FAQs.GBR,
  },
  {
    key: 'termsAndConditions',
    link: TANDCs.GBR,
  },
  {
    key: 'privacyPolicy',
    link: PRIVACY.GBR,
  },
]

const USAFooterLinks: FooterLink[] = [
  {
    key: 'faqs',
    link: FAQs.USA,
  },
  {
    key: 'termsAndConditions',
    link: TANDCs.USA,
  },
  {
    key: 'privacyPolicy',
    link: 'https://www.babylonhealth.com/us/privacy',
  },
]

const CANFooterLinks: FooterLink[] = [
  {
    key: 'faqs',
    link: FAQs.CAN,
  },
  {
    key: 'termsAndConditions',
    link: TANDCs.CAN,
  },
  {
    key: 'privacyPolicy',
    link: 'https://www.babylonhealth.com/ca/telus/privacy-policy',
  },
]

const premadeFooterLinks: PremadeFooterLinks = {
  GBR: GBRFooterLinks,
  USA: USAFooterLinks,
  CAN: CANFooterLinks,
}

export default premadeFooterLinks
export { FAQs }
